import { Injectable } from '@angular/core';
import { LoadingController, Loading } from 'ionic-angular';
import { Constants } from '../../util/Constants';
import { Subject } from 'rxjs/Subject';

/*
  Generated class for the LoadingCtrlProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class LoadingCtrlProvider {
  subject: Subject<any> = new Subject<any>();

  private cmdLoading: Loading;
  private cmd: number = null;

  constructor(private loadingCtrl: LoadingController) {
    this.subject.throttleTime(1000).subscribe(reqCmd => {
      console.log("Subscribe received: " + reqCmd);
      this.showLoading(reqCmd);
    });
  }

  private showLoading(reqCmd) {
    this.cmdLoading = this.loadingCtrl.create({
      content : "Loading",
      duration: 20000
    });
    this.cmdLoading.present();
    this.cmd = reqCmd;
    console.log("showLoading: " + reqCmd);
  }

  public createCmdLoading(reqCmd: number) {
    if (this.cmd == null && Constants.WS_CODE_PING_REQUEST != reqCmd && Constants.WS_CODE_GET_RACE_DAY_INFO_REQUEST != reqCmd
          && Constants.WS_CODE_GET_USER_REQUEST != reqCmd) {
      this.subject.next(reqCmd);
    }
  }

  public dismissCmdLoading(reqCmd: number) {
    console.log("dismissAllCmdLoading1: " + reqCmd);
    if (reqCmd == this.cmd) {
      console.log("dismissAllCmdLoading2: " + reqCmd);
      this.cmdLoading.dismiss();
      this.cmd = null;
    }
  }

  public create() {
    let loading:Loading = this.loadingCtrl.create({
      content: "Loading",
      duration: 5000
    });
    loading.present();
    return loading;
  }
}



// WEBPACK FOOTER //
// ./src/providers/loading-ctrl/loading-ctrl.ts